import { createAction } from 'redux-act';
import { FlowStoppedReason } from "../../constants";
export var startFlow = createAction('Start flow', function (flowId, options) {
  return {
    flowId: flowId,
    options: options
  };
});
export var stopFlow = createAction('Stop flow', function (flowId) {
  var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FlowStoppedReason.CLOSED;
  return {
    flowId: flowId,
    reason: reason
  };
});
export var addFlowData = createAction('Add flow data', function (flowId, data) {
  return {
    flowId: flowId,
    data: data
  };
});
export var removeFlowData = createAction('Remove flow data', function (flowId, key) {
  return {
    flowId: flowId,
    key: key
  };
});
export var resetFlow = createAction('Reset flow', function (flowId) {
  return {
    flowId: flowId
  };
});
export var changeFlowStep = createAction('Change flow step', function (flowId, step) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'forward';
  return {
    flowId: flowId,
    step: step,
    direction: direction
  };
});
export var stepForward = createAction('Advance flow step');
export var stepBack = createAction('Flow step back');
export var changeAuthType = createAction('Switch between reg/signin steps');